import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

const features = [
  {
    title: 'Case Management',
    description:
      'One structured record per case, feeding a live settlement summary that updates as you negotiate.',
    icon: '/images/briefcase.svg',
  },
  {
    title: 'Lien Management',
    description:
      'Type-aware defaults for chiropractic, imaging, ambulance, and statutory liens — percentage or flat fee, calculated automatically.',
    icon: '/images/circle-x.svg',
  },
  {
    title: 'AI-Assisted Reduction Letters',
    description:
      "Generate a complete reduction letter in seconds — pick a tone, edit inline, send from your firm's own address.",
    icon: '/images/sparkles.svg',
  },
  {
    title: 'Automated Follow-Up Cadence',
    description:
      'A fixed follow-up schedule chases non-responsive providers automatically, until a response is recorded.',
    icon: '/images/clock-arrow-up.svg',
  },
  {
    title: 'Provider Directory',
    description:
      "A searchable directory of every provider you've worked with — auto-fill contact details instead of retyping them.",
    icon: '/images/contact.svg',
  },
  {
    title: 'Reporting & Dashboard',
    description:
      'Firm-wide visibility into open cases, pending responses, and undisbursed funds — no digging through inboxes.',
    icon: '/images/bar-chart-2.svg',
  },
];

const System = () => {
  return (
    <section className="system" aria-labelledby="system-heading">
      <Container>
        <Row className="justify-content-center text-center">
          <Col xs={12} lg={8}>
            <p className="system__eyebrow">Everything In One System</p>
            <h2 id="system-heading" className="system__title">
              Built for how settlement teams actually work.
            </h2>
          </Col>
        </Row>

        <Row className="g-3 g-lg-4">
          {features.map((feature) => (
            <Col key={feature.title} xs={12} sm={6} lg={4}>
              <article className="system__card h-100">
                <div className="system__icon">
                  <img src={feature.icon} alt="" width={20} height={20} />
                </div>
                <h3 className="system__card-title">{feature.title}</h3>
                <p className="system__card-text mb-0">{feature.description}</p>
              </article>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default System;
